import businessContent from './markdown/business';
import categoryContent from './markdown/category';
import employeeContent from './markdown/employee';
import eventContent from './markdown/event';
import groupContent from './markdown/group';
import guideContent from './markdown/guide';
import historyContent from './markdown/history';
import mainVisualContent from './markdown/mainVisual';
import materialContent from './markdown/material';
import menuContent from './markdown/menu';
import newsContent from './markdown/news';
import noticeContent from './markdown/notice';
import partnerContent from './markdown/partner';
import popupContent from './markdown/popup';
import recruitmentContent from './markdown/recruitment';
import settingsContent from './markdown/settings';

export const DEFAULT_MENU_SID = 9; // 공지사항
export const DEFAULT_PARENT_MENU_SID = 17; // 공지사항 부모 header category
export const DEFAULT_PARENT_MENU_SID_CONTENTS = 14; // 14 contents
// 메뉴 상수 정의
export const MENU_ID = {
  RECRUIT: 'recruit',
  POPUP: 'popup',
  MAIN_VISUAL: 'mainVisual',
  BUSINESS: 'business',
  CATEGORY: 'category',
  PARTNER: 'partner',
  HISTORY: 'history',
  SETTINGS: 'settings',
  MATERIAL: 'material',
  EVENT: 'event',
  NEWS: 'news',
  NOTICE: 'notice',
  MENU: 'menu',
  EMPLOYEE: 'employee',
  GROUP: 'group',
  GUIDE: 'guide',
} as const;

// 메뉴 타입 정의
export type MenuType = (typeof MENU_ID)[keyof typeof MENU_ID];

interface IManualContent {
  title: string;
  content: string;
}

// 메뉴얼 콘텐츠 정의
export const GUIDE_CONTENT: Record<MenuType, IManualContent> = {
  [MENU_ID.RECRUIT]: recruitmentContent,
  [MENU_ID.POPUP]: popupContent,
  [MENU_ID.MAIN_VISUAL]: mainVisualContent,
  [MENU_ID.BUSINESS]: businessContent,
  [MENU_ID.CATEGORY]: categoryContent,
  [MENU_ID.PARTNER]: partnerContent,
  [MENU_ID.HISTORY]: historyContent,
  [MENU_ID.SETTINGS]: settingsContent,
  [MENU_ID.MATERIAL]: materialContent,
  [MENU_ID.EVENT]: eventContent,
  [MENU_ID.NEWS]: newsContent,
  [MENU_ID.NOTICE]: noticeContent,
  [MENU_ID.MENU]: menuContent,
  [MENU_ID.EMPLOYEE]: employeeContent,
  [MENU_ID.GROUP]: groupContent,
  [MENU_ID.GUIDE]: guideContent,
};

// 메뉴 ID 매핑 함수
export const getMenuType = (menuSid: number): MenuType | undefined => {
  const menuMapping: Record<number, MenuType> = {
    2: MENU_ID.RECRUIT,
    1: MENU_ID.POPUP,
    3: MENU_ID.MAIN_VISUAL,
    4: MENU_ID.BUSINESS,
    21: MENU_ID.CATEGORY,
    5: MENU_ID.PARTNER,
    6: MENU_ID.HISTORY,
    20: MENU_ID.SETTINGS,
    8: MENU_ID.MATERIAL,
    7: MENU_ID.EVENT,
    9: MENU_ID.NEWS,
    10: MENU_ID.NOTICE,
    23: MENU_ID.GUIDE,
    11: MENU_ID.MENU,
    12: MENU_ID.EMPLOYEE,
    13: MENU_ID.GROUP,
  };

  return menuMapping[menuSid];
};
